

export const doRequest = async({ commit }, { id, request }) => {

    commit('fetching', { id, request })

    try {
        return await request;
    } catch(err) {
        throw err
    } finally {
        commit('fetched', id)
    }
}

export default {
    doRequest
}
